var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"is-flex"},[_c('BButton',{staticClass:"is-flex-grow-1 text-overflow-tidy",attrs:{"type":_vm.type,"size":"is-small","icon-left":_vm.icon,"disabled":!_vm.canDownload},on:{"click":function($event){return _vm.onClick()}}},[_c('SensitiveField',[_vm._v(_vm._s(_vm.message))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }